<dx-popup
  [style]="{'width':'calc(90vw)','height':'calc(80vh)'}"
  [showTitle]="true"
  title="CRÉER UNE NOUVELLE PROPOSITION DE COMMANDE"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="displayDialog"
  [fullScreen]="fullScreen"
  (onHiding)="closeDialog()"
>

  <dxi-toolbar-item
    widget="dxButton"
    location="after"
    [options]="{
            icon: 'fullscreen',
            onClick: toggleFullScreen
        }">
  </dxi-toolbar-item>

  <div class="d-flex flex-row align-content-center mg-b-10">
    <div class="mg-r-10 align-self-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
    </div>
    <div class="mg-r-10 align-self-center">
      <yo-button
        class="mg-r-15 mg-t-10"
        label="AJOUTER"
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        tooltip="Ajouter des déclinaisons"
        (onClick)="openAjoutDenree()"></yo-button>
    </div>
    <div class="mg-r-10 align-self-center">
      <label class="mg-r-5">Unité de production : </label>
      <p-dropdown [options]="uniteDeProductionList"
                  [(ngModel)]="uniteDeProductionSelected"
                  (onChange)="onChangeUniteDeProduction($event)"
                  optionLabel="libelle"
                  [filter]="true"
                  filterBy="libelle"
                  [showClear]="true"
                  placeholder="Selectionner une unité de production">
      </p-dropdown>
    </div>
    <div class="mg-r-10 align-self-center">
      <label class="mg-r-5">Date de livraison au plus tard : </label>
    </div>
    <div class="mg-r-10 align-self-center">
      <dx-date-box #datebox id="dateLiv"
                   [min]="minDate"
                   [value]="dateSelected"
                   type="date"
                   [displayFormat]="'dd/MM/yyyy'"
                   (onValueChanged)="changeDateLivraisonMax($event)"
                   [calendarOptions]="{ cellTemplate: 'dayCellTemplate', firstDayOfWeek: 1}"
                   [disabledDates]="disabledDates"
                   >
        <div *dxTemplate="let data of 'dayCellTemplate'">
          @if (this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)) {
            <div class="disabled-day-fermeture-ponctuelle" title="Fermeture ponctuelle de la cuisine">
              {{ data.text }}
            </div>
          }
          @if (!this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)) {
            <div>{{ data.text }}</div>
          }
        </div>
      </dx-date-box>
    </div>
    <div class="mg-r-30 d-flex align-items-center">
      <label [title]="'Scénario de pré-sélection des articles'" class="mg-r-5">Scénario : </label>
      <p-dropdown [options]="optionScenarioArticle"
                  [(ngModel)]="scenarioArticleSelected"
                  optionLabel="key"
                  (onChange)="onChangeScenarioArticle($event)"
                  [filter]="true"
                  [showClear]="true">
      </p-dropdown>
    </div>
    <div class="mg-r-10 align-self-center">
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        class="mg-r-15 mg-t-10"
        label="Simulation des commandes"
        tooltip="Simulation des commandes"
        (onClick)="calculerFraisDePort()"></yo-button>
    </div>
  </div>

  <dx-data-grid
    [dataSource]="commandeDenreeList"
    keyExpr="idProduitDeclinaison"
    height="80%"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
      [noDataText]="hasConfigurationLivraisonForSelectedUdp() ? 'Votre panier est vide' : 'Pas de données'"
    [showBorders]="true"
    (onCellPrepared)="onCellPrepared($event)"
    (onRowUpdating)="onRowUpdating($event)"
    #gridDenreeSelected>
    <dxi-column alignment="center" caption="Action(s)" cellTemplate="actionsCellTemplate"></dxi-column>
    <dxi-column dataField="libelleProduitDeclinaison" alignment="left" caption="Déclinaison"
                [allowEditing]="false"
                [allowFiltering]="true">
    </dxi-column>
    <dxi-column dataField="codeProduitDeclinaison" alignment="left" caption="Code"
                [allowEditing]="false"
                [allowFiltering]="true">
    </dxi-column>
    <dxi-column dataField="" alignment="left" caption="Fournisseur" cellTemplate="providerCellTemplate"
                [allowEditing]="false"
                [allowFiltering]="true">
    </dxi-column>
    <dxi-column dataField="libelleArticleSelected" caption="Article"
                [allowEditing]="true"
                [allowFiltering]="false"
                cellTemplate="articleCellTemplate"
                editCellTemplate="editArticleCellTemplate">
    </dxi-column>
    <dxi-column dataField="quantiteUT" alignment="left" caption="Quantité UT"
                cellTemplate="quantiteUTCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="true">
    </dxi-column>
    <dxi-column dataField="quantiteUF" alignment="left" caption="Quantité UF"
                cellTemplate="quantiteUFCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="quantiteUC" alignment="left" caption="Quantité UC"
                cellTemplate="quantiteUCCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="quantiteUTArrondie" alignment="left" caption="Quantité arrondie en UT"
                cellTemplate="quantiteUCArrondieCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="gacaSelected.prixUF.value" alignment="left" caption="PU UF"
                cellTemplate="prixUFCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="gacaSelected.prixUC.value" alignment="left" caption="Prix total"
                cellTemplate="prixTotalCellTemplate"
                [allowFiltering]="false"
                [allowEditing]="false">
    </dxi-column>
    <dxi-column dataField="dateLivraisonPossible" alignment="left" dataType="date" caption="Date de livraison"
                [allowEditing]="false"
                [allowFiltering]="true">
    </dxi-column>

    <!--    TEMPLATE-->
    <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
      <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" (onClick)="removeFeed(cell.row.data)"
                      iconClass="fa fa-trash"
                      tooltip="Supprimer cette denrée de la sélection"
      ></yo-button>
    </div>

    <div *dxTemplate="let cell of 'providerCellTemplate'">
      {{ getProviderLabel(cell.row.data) }}
    </div>

    <div *dxTemplate="let cell of 'editArticleCellTemplate'">
      <dx-drop-down-box
        [dropDownOptions]="dropDownOptions"
        [dataSource]="cell.data.catalogueAchatList"
        [(value)]="cell.value"
        displayExpr="produitArticle.libelle"
        valueExpr="id"
        contentTemplate="contentTemplate">

        <div *dxTemplate="let e of 'contentTemplate'">
          <yo-grille-remplacer-article
            [udpSfPrefereList]="udpSfPrefereList"
            [articlesDisponibles]="cell.data.catalogueAchatList"
            [unicityIdForGroupeName]=" cell.data.idProduitDeclinaison"
            [selectedGacaViewModel]="cell.data.gacaSelected"
            [idUdp]="this.uniteDeProductionSelected?.id"
            (updatePrixUnitaireUF)="updatePrixUnitaireCommande(e.component, $event, cell.data)">
          </yo-grille-remplacer-article>
        </div>
      </dx-drop-down-box>
    </div>


    <div *dxTemplate="let cell of 'articleCellTemplate'">
      <span [ngClass]="utils.isNullOrEmpty(cell.row.data.libelleArticleSelected) ? 'font-warning' :''">
        {{utils.isNullOrEmpty(cell.row.data.libelleArticleSelected) ? 'Pas d\'article pour cette denrée' : cell.row.data.libelleArticleSelected}}
      </span>
      <br/>
      @if (!utils.isNullOrEmpty(cell.row.data.libelleArticleSelected)) {
        <yo-info-lotmarche-article
          [uniteDeProductionId]="uniteDeProductionSelected.id"
          [lotMarchePdLumpCa]="getLmPdUpCa(cell.row.data)">
        </yo-info-lotmarche-article>
      }
    </div>

    <div *dxTemplate="let cell of 'quantiteUTCellTemplate'">
      @if (!utils.isNullOrEmpty(cell.row.data.libelleArticleSelected)) {
        <div>
          <span [ngClass]="cell.row.data?.quantiteUT === 0 ? 'font-warning': ''">{{cell.row.data?.quantiteUT}}</span>
          <span [title]="getUniteDeMesureLibelle(cell.row.data, TYPE_UNITE_DE_MESURE.uniteTechnique)"
                [ngClass]="cell.row.data?.quantiteUT === 0 ? 'font-warning': ''">
            {{getUniteDeMesureAbrevation(cell.row.data, TYPE_UNITE_DE_MESURE.uniteTechnique)}}
          </span>
        </div>
      }
    </div>

    <div *dxTemplate="let cell of 'quantiteUFCellTemplate'">
      @if (!utils.isNullOrEmpty(cell.row.data.libelleArticleSelected)) {
        <div>
          <span>{{getQuantiteUFFromUT(cell.row.data)}}</span>
          <span [title]="getUniteDeMesureLibelle(cell.row.data, TYPE_UNITE_DE_MESURE.uniteDeFacturation)">
            {{getUniteDeMesureAbrevation(cell.row.data, TYPE_UNITE_DE_MESURE.uniteDeFacturation)}}
          </span>
        </div>
      }
    </div>

    <div *dxTemplate="let cell of 'quantiteUCCellTemplate'">
      @if (!utils.isNullOrEmpty(cell.row.data.libelleArticleSelected)) {
      <div [title]="getQuantiteUCTooltip(cell.row.data)">
        <span>{{getQuantiteUCFromUT(cell.row.data)}} </span>
        <span [title]="getUniteDeMesureLibelle(cell.row.data, TYPE_UNITE_DE_MESURE.uniteDeCommande)">
          {{getUniteDeMesureAbrevation(cell.row.data, TYPE_UNITE_DE_MESURE.uniteDeCommande)}}
        </span>
        @if (getSelectedCa(cell.row.data)?.delaiCommande && isOutOfDate(getSelectedCa(cell.row.data)?.delaiCommande)) {
          <i class="fas fa-business-time danger-color" title="Article avec délai de commande spécifique dépassé ({{getSelectedCa(cell.row.data)?.delaiCommande}}j)"></i>
        }
        @if (isBelowMinimumCommande(cell.row.data)) {
            <i class="fas fa-cart-arrow-down danger-color space"
               title="Minimum de commande {{getSelectedCa(cell.row.data)?.minimumDeCommande}} {{getSelectedCa(cell.row.data)?.uniteDeCommande?.libelle}}"></i>
        }
        @if (isConditionneParInError(cell.row.data)) {
            <i class="fas fa-box-open danger-color space"
               title="Conditionné par {{getSelectedCa(cell.row.data)?.conditionnePar}} {{getSelectedCa(cell.row.data)?.uniteDeCommande?.libelle}}"></i>
        }
      </div>
      }
    </div>

    <div *dxTemplate="let cell of 'quantiteUCArrondieCellTemplate'">
      @if (!utils.isNullOrEmpty(cell.row.data.libelleArticleSelected)) {
        <div>
          <span>{{getQuantiteUTFromUC(cell.row.data)}}</span>
          <span [title]="getUniteDeMesureLibelle(cell.row.data, TYPE_UNITE_DE_MESURE.uniteTechnique)">
            {{getUniteDeMesureAbrevation(cell.row.data, TYPE_UNITE_DE_MESURE.uniteTechnique)}}
          </span>
        </div>
      }
    </div>

    <div class="float-right" *dxTemplate="let cell of 'prixUFCellTemplate'">
      {{cell.row.data.gacaSelected?.prixUF?.value |currency:'EUR':'symbol':'1.4-4'}} / {{showUniteFacturationLibelle(cell.row.data)}}
    </div>

    <div class="float-right" *dxTemplate="let cell of 'prixTotalCellTemplate'">
      {{showPrixTotal(cell.row.data) |currency:'EUR':'symbol':'1.4-4'}}
    </div>

    <!--    OPTION-->
    <dxo-editing mode="cell" [allowUpdating]="true" [confirmDelete]="false">
    </dxo-editing>

    <dxo-pager
      [showPageSizeSelector]="false"
      [showNavigationButtons]="true"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} Déclinaison(s)">
    </dxo-pager>
  </dx-data-grid>

  <hr/>
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column">
      <div><label class="font-12 genlabel"><i class="fas fa-info-circle mg-r-5"></i> Ajoutez des denrées à votre panier
        puis sélectionnez l'unité de production qui va en bénéficier ainsi que la date de livraison souhaitée. Vérifiez
        ensuite que les articles
        préselectionnés correspondent à vos besoins</label></div>
    </div>
    <div class="d-flex">
      <span class="mg-r-5">
        <yo-button iconClass="fas fa-save"
                   (onClick)="checkBeforeSavePropositionList()"
                   [disabled]="isDisabledSaveBtn()"
                   tooltip="Enregistrer"
                   [theme]="ButtonThemeEnum.SAVE">
        </yo-button>
      </span>
      <span class="mg-r-5">
        <yo-button iconClass="fas fa-times" tooltip="Fermer" (onClick)="closeDialog()"
                   [theme]="ButtonThemeEnum.DELETE_INNER">
        </yo-button>
      </span>
    </div>
  </div>
  <!-- </p-dialog> -->
</dx-popup>

<!--DIALOG AJOUT DENREE POUR LA PROPOSITION DE COMMANDE-->
<yo-ajout-denree-proposition-commande></yo-ajout-denree-proposition-commande>

<yo-possible-delivery-dates></yo-possible-delivery-dates>

<yo-frais-de-port></yo-frais-de-port>
